<template>
  <div>
    <h4 class="mb-5">{{ student_name }}</h4>
    <vs-divider />
    <vx-card class="mt-base mb-5">
      <h4 class="mb-5">View Student Prework activities</h4>
      <p class="mb-5">
        This is where you can see everything about a student's experience(s) and track their
        progress.
      </p>
      <p class="mb-10">
        To see the student's submitted work for the various sections and activities, click the "View
        Section" or "View Experience" buttons below
      </p>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/5 mb-base"></div>

        <div
          class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center flex flex-col items-center"
        >
          <h5 class="flex-1">Workplace Safety</h5>
          <status-icon
            :type="prework !== false && prework.status.section_ws ? 'completed' : 'not_completed'"
            class="prework_icon my-5"
          /><br />
          <router-link
            :to="'/teacher/vje/prework/' + this.$route.params.id + '/workplace-safety'"
            class="btn btn-primary btn-size-small"
            >View Section</router-link
          >
        </div>
        <div
          class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center flex flex-col items-center"
        >
          <h5 class="flex-1">Workplace Preparation</h5>
          <status-icon
            :type="prework !== false && prework.status.section_wp ? 'completed' : 'not_completed'"
            class="prework_icon my-5"
          /><br />
          <router-link
            :to="'/teacher/vje/prework/' + this.$route.params.id + '/workplace-preparation'"
            class="btn btn-primary btn-size-small"
            >View Section</router-link
          >
        </div>
        <div
          class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center flex flex-col items-center"
        >
          <h5 class="flex-1">Apply for a Position</h5>
          <status-icon
            :type="
              prework !== false && prework.status.section_apply ? 'completed' : 'not_completed'
            "
            class="prework_icon my-5"
          /><br />
          <router-link
            :to="'/teacher/vje/prework/' + this.$route.params.id + '/application'"
            class="btn btn-primary btn-size-small"
            >View Section</router-link
          >
        </div>

        <div class="vx-col w-full lg:w-1/5 mb-base"></div>
      </div>
    </vx-card>

    <vs-table ref="table" :data="experiences">
      <template slot="thead">
        <vs-th scope="col" sort-key="name" width="5%">#</vs-th>
        <vs-th scope="col" width="15%">Active Experience Status</vs-th>
        <vs-th scope="col" sort-key="name" width="15%">Work Experience</vs-th>
        <vs-th scope="col" sort-key="name" width="9%">Type</vs-th>
        <vs-th scope="col" sort-key="email" width="12%">Date Started</vs-th>
        <vs-th scope="col" sort-key="order_status" width="9%">Pre-Work</vs-th>
        <vs-th scope="col" sort-key="order_status" width="9%">Induction</vs-th>
        <vs-th scope="col" sort-key="order_status" width="9%">Activities<br />(Classic)</vs-th>
        <vs-th scope="col" sort-key="order_status" width="9%">Project<br />(Comprehensive)</vs-th>
        <vs-th scope="col" sort-key="order_status" width="13%">Certificate Requested</vs-th>
        <vs-th scope="col" width="10%">Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td>
              <vs-chip color="primary" v-if="tr.experience_name !== null">In Progress</vs-chip>
              <vs-chip color="warning" v-if="tr.experience_name == null">Prework</vs-chip>
            </vs-td>
            <vs-td>{{ tr.experience_name }}</vs-td>
            <vs-td>
              <vs-chip color="warning" v-if="tr.type == 1">Virtual</vs-chip>
              <vs-chip color="primary" v-else>Real World</vs-chip>
            </vs-td>
            <vs-td>{{ tr.date_experience_started }}</vs-td>
            <vs-td>
              <status-icon :type="prework.status.completed ? 'completed' : 'not_completed'" />
            </vs-td>
            <vs-td>
              <status-icon :type="tr.intro_completed ? 'completed' : 'not_completed'" />
            </vs-td>
            <vs-td>
              <status-icon :type="tr.activities_completed ? 'completed' : 'not_completed'" />
            </vs-td>
            <vs-td>
              N/A
              <status-icon
                :type="tr.projects_completed ? 'completed' : 'not_completed'"
                class="hidden"
              />
            </vs-td>
            <vs-td>
              <div class="flex whitespace-no-wrap">
                <status-icon
                  :type="tr.certificate_status > 0 ? 'completed' : 'not_completed'"
                  class="certificate_status"
                />
                <vs-chip color="primary" v-if="tr.certificate_status == 2">Approved</vs-chip>
                <vs-chip color="warning" v-else-if="tr.certificate_status == 1"
                  >Not Approved</vs-chip
                >
                <vs-chip color="dark" v-else-if="tr.certificate_status == 3">Declined</vs-chip>
                <vs-chip color="danger" v-else>Not Requested</vs-chip>
              </div>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <button
                class="btn btn-primary btn-size-small"
                @click="viewExperience(tr.id, tr.type, tr.certificate_status)"
              >
                View Experiences
              </button>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import router from '@/router/router';
import StatusIcon from '@/components/UI/StatusIcon';
import theApi from '@/mixins/theApi';

export default {
  components: { StatusIcon },
  data() {
    return {
      experiences: [],
      prework: false,
      student_name: '',
    };
  },
  methods: {
    async loadStudents() {
      theApi.methods.makeCall(true, 'vje_students/student/' + this.$route.params.id, 'get').then(
        (data) => {
          this.experiences = data.data.experiences;
          this.prework = data.data.prework;
          this.student_name = data.data.student_name;
        },
        () => {},
      );
    },
    viewExperience(experienceID, type, certificate_status) {
      if (type == 1) {
        if (certificate_status == 3)
          router.push('/teacher/vje/experience/view/' + experienceID + '/certificate');
        else router.push('/teacher/vje/experience/view/' + experienceID + '/activities');
      } else {
        router.push('/teacher/vje/experience/view/' + experienceID + '/experience-info');
      }
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>

<style>
.certificate_status {
  float: left;
  margin-right: 10px;
  margin-top: 2px;
}
.prework_icon .status_icon {
  width: 40px !important;
  height: 40px !important;
}
</style>
